const LEGACY_OPEN_APP_MARKERS = [
  '\n\nОткрыть заявку: ',
  '\n\nOpen application: ',
]

/** Убрать из body URL, добавленный в старых уведомлениях до отдельного поля application_url. */
export function notificationBodyText(body: string): string {
  for (const marker of LEGACY_OPEN_APP_MARKERS) {
    const idx = body.indexOf(marker)
    if (idx >= 0) {
      return body.slice(0, idx).trimEnd()
    }
  }
  return body
}

export function legacyApplicationUrlFromBody(body: string): string | null {
  for (const marker of LEGACY_OPEN_APP_MARKERS) {
    const idx = body.indexOf(marker)
    if (idx >= 0) {
      const url = body.slice(idx + marker.length).trim()
      return url || null
    }
  }
  return null
}

const LEGACY_COMPANY_APPLICATIONS_PREFIX = '/company/applications'

/** Старые уведомления и письма могли содержать /company/applications — раздел в SPA calculator. */
export function normalizeApplicationLinkPath(pathname: string): string {
  if (pathname === LEGACY_COMPANY_APPLICATIONS_PREFIX || pathname.startsWith(`${LEGACY_COMPANY_APPLICATIONS_PREFIX}/`)) {
    return `/cabinet/applications${pathname.slice(LEGACY_COMPANY_APPLICATIONS_PREFIX.length)}`
  }
  return pathname
}

export function applicationLinkPath(applicationUrl: string | null | undefined): string | null {
  if (!applicationUrl?.trim()) return null
  const raw = applicationUrl.trim()
  try {
    const url = new URL(raw)
    return normalizeApplicationLinkPath(`${url.pathname}${url.search}`)
  } catch {
    const path = raw.startsWith('/') ? raw : `/${raw}`
    const [ pathname, search = '' ] = path.split('?')
    const normalized = normalizeApplicationLinkPath(pathname)
    return search ? `${normalized}?${search}` : normalized
  }
}
